import React from 'react';
import { RocketLaunchIcon, UserIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import { Link } from 'react-router-dom';

const TransparencyCharterFinalThoughts = () => {
  return (
    <div className="space-y-8">
      <PlaybookSection 
        title="Final Thoughts" 
        icon={<RocketLaunchIcon className="h-7 w-7 text-primary-light" />} 
        heading
      >
        <PlaybookCard>
          <h3 className="text-xl font-semibold text-white mb-4">Summary</h3>
          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300">
              Using this playbook offers you a step-by-step guide you can follow to define & describe what transparency means in your business, so you can set expectations both internally & externally around what information is communicated & shared, and what isn't, and why. It will help get everyone on the same page, and is a powerful alignment tool for applicants during hiring; people join fully understanding exactly what level of transparency they're subscribing to. It sets foundations for you to build consistency around communication, which helps to generate trust.
            </p>
            
            
          </div>
        </PlaybookCard>
      </PlaybookSection>
    </div>
  );
};

export default TransparencyCharterFinalThoughts; 